import { ScaffoldDetails } from './scaffold-details';
import { SiteDetails } from './site-details';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class DiaryActivityDetails {
  ActivityId: string;
  ScaffoldDetails: ScaffoldDetails;
  SiteDetails: SiteDetails;
  ActivityDateTime: string;
  ScaffoldId: string;
  OwnerId: string;
  OwnerName: string;
  StaffCompanyPosition: string;
  Notes: string;
  TranscriptionsCount: number;
  AudiosCount: number;
  ImagesCount: number;
  VideosCount: number;
  PDFCount: number;
  PercentageStanding: number;
  DiaryCategoryId: string;
}


